var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheelsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 322 71.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#da1f33;}.cls-2{fill:#1c1d1d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "scheels-eo-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.1,12.44S44.45.13,23.63.13,1.52,10.84,1.51,14.06c0,1.8,1.59,11.16,18.44,12.81,9.66.95,11.25,1.51,11.23,3,0,1.11-1.5,2.31-4.87,2.35-3,0-7.43-.52-8.57-3.67H0S.32,41.09,23.61,41.16c20.75.05,24.53-6.92,24.48-13.6,0,0,1.1-9.52-15.46-12.24-8.83-1.45-16.21-1.2-15.83-4.54S27.88,9,28.51,12.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.22,13H97.57S95.05.16,74,.16C54.61.16,50.81,12.93,50.81,21.44S57.46,41.21,74,41.2c21.21,0,23.61-13.3,23.6-13.32H79.08s.19,3.47-5.11,3.47-6.89-6.56-6.88-10.73C67.1,16,68.85,9.71,74,9.71S79.22,13,79.22,13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "127.26 12.44 116.06 12.44 116.06 0.1 100.48 0.1 100.48 41.2 116.06 41.2 116.06 22.69 127.26 22.69 127.26 41.19 142.85 41.19 142.85 0.1 127.27 0.1 127.26 12.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "185.97 10.86 185.97 0.09 147.5 0.08 147.5 41.19 185.97 41.19 185.97 30.46 163.31 30.46 163.31 25.68 181.89 25.68 181.89 15.59 163.31 15.59 163.31 10.86 185.97 10.86 185.97 10.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "248.92 0.06 248.92 0.04 233.11 0.04 233.11 41.18 233.97 41.18 233.97 41.19 266.45 41.19 266.45 30.41 248.92 30.41 248.92 0.06 248.92 0.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.34,4.71h.3a.71.71,0,0,0,.26,0,.52.52,0,0,0,.18-.15.55.55,0,0,0,.06-.28.43.43,0,0,0-.06-.24.4.4,0,0,0-.15-.14,1.14,1.14,0,0,0-.22-.07h-.87v1Zm.21-1.33a1.25,1.25,0,0,1,.8.21.77.77,0,0,1,.26.65.7.7,0,0,1-.23.59,1,1,0,0,1-.56.22l.87,1.35h-.51l-.83-1.31h-.51V6.4h-.47v-3ZM317.4,5.76a2.13,2.13,0,0,0,.46.7,2,2,0,0,0,.68.47,2.15,2.15,0,0,0,.85.17,2.22,2.22,0,0,0,.85-.17,2,2,0,0,0,.67-.47,2.13,2.13,0,0,0,.46-.7,2.3,2.3,0,0,0,.16-.88,2.28,2.28,0,0,0-.16-.87,2.24,2.24,0,0,0-.46-.7,2.1,2.1,0,0,0-.67-.46,2.22,2.22,0,0,0-.85-.17,2.14,2.14,0,0,0-1.53.63,2.24,2.24,0,0,0-.46.7,2.47,2.47,0,0,0,0,1.75ZM317,3.86a2.77,2.77,0,0,1,.56-.82,2.63,2.63,0,0,1,.84-.54,2.67,2.67,0,0,1,1-.2,2.64,2.64,0,0,1,1,.2,2.53,2.53,0,0,1,1.39,1.36,2.48,2.48,0,0,1,.21,1,2.59,2.59,0,0,1-.77,1.86,2.46,2.46,0,0,1-.83.55,2.63,2.63,0,0,1-1,.19,2.67,2.67,0,0,1-1-.19,2.5,2.5,0,0,1-.84-.55,2.77,2.77,0,0,1-.56-.82,2.58,2.58,0,0,1-.21-1,2.48,2.48,0,0,1,.21-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "228.7 10.86 228.7 0.09 190.23 0.08 190.23 41.19 228.7 41.19 228.7 30.46 206.04 30.46 206.04 25.68 224.62 25.68 224.62 15.59 206.04 15.59 206.04 10.86 228.7 10.86 228.7 10.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M316.78,12.34S313.13,0,292.31,0s-22.1,10.73-22.11,14c0,1.8,1.59,11.18,18.43,12.84,9.66.95,11.25,1.51,11.23,3,0,1.12-1.5,2.31-4.86,2.36-3,0-7.44-.52-8.58-3.68H268.68s.32,12.54,23.61,12.6c20.75.06,24.54-6.93,24.49-13.62,0,0,1.09-9.54-15.46-12.26-8.84-1.46-16.22-1.21-15.84-4.56s11.08-1.75,11.71,1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.48,53.6h6.8v2.1H86v5.65h4v2.1H86v6.1h4.3v2.1h-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.83,53.6h4l2.3,13.75h0l2.3-13.75h3.87V71.65H103V55.4h0l-2.55,16.25h-2.5L95.08,55.4h0V71.65h-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.33,53.6h4.13c3.4,0,4.05.93,4.05,5.1s-.65,5.1-4.05,5.1h-1.63v7.85h-2.5Zm2.5,8.1h1.3c1.7,0,1.88-.28,1.88-3s-.18-3-1.88-3h-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.18,53.6h2.5V69.55h4.2v2.1h-6.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128,58.2c0-2.52.83-4.75,4.23-4.75,3.22,0,4.25,1.68,4.25,4.48v9.12c0,2.52-.83,4.75-4.25,4.75-3.2,0-4.23-1.68-4.23-4.48Zm2.5,9.27c0,1.55.7,2.38,1.73,2.38S134,69,134,67.47V58c0-1.77-.6-2.6-1.75-2.6s-1.73.83-1.73,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.31,53.6h2.5L143,61.2H143l2.5-7.6h2.2l-3.47,10.65v7.4h-2.5v-7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M150.39,53.6h6.8v2.1h-4.3v5.65h4.05v2.1h-4.05v6.1h4.3v2.1h-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M159.74,53.6h6.8v2.1h-4.3v5.65h4v2.1h-4v6.1h4.3v2.1h-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M174.69,58.2c0-2.52.82-4.75,4.22-4.75,3.23,0,4.25,1.68,4.25,4.48v9.12c0,2.52-.82,4.75-4.25,4.75-3.2,0-4.22-1.68-4.22-4.48Zm2.5,9.27c0,1.55.7,2.38,1.72,2.38s1.75-.83,1.75-2.38V58c0-1.77-.6-2.6-1.75-2.6s-1.72.83-1.72,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M185.34,53.6h2.57l1.8,14.85h0l2-14.85h3.4l1.65,14.85h.05L199,53.6h2.35l-3.25,18.05h-3.05l-1.67-15.1h0l-2.13,15.1h-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.61,53.6h3.45l2.95,15h.05v-15h2.35V71.65h-3.6l-2.95-15.4h-.05v15.4h-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M215.4,53.6h6.8v2.1h-4.3v5.65h4v2.1h-4v6.1h4.3v2.1h-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M224.75,53.6h4c4,0,4.38,1.35,4.38,6.6v5.37c0,4.63-.83,6.08-4.78,6.08h-3.62Zm2.5,15.95h1.2c1.85,0,2.2-1,2.2-4.08V59.28c0-2.68-.28-3.58-2.4-3.58h-1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheelsLogo);
export default __webpack_public_path__ + "static/media/scheels-logo.cfbfe32dd2f619562642ee9151dfed07.svg";
export { ForwardRef as ReactComponent };